export const getObjectDiff = (oldObj: object, newObj: object) => {
  const diff = {};
  Object.keys(oldObj).forEach((key) => {
    // @ts-ignore
    if (JSON.stringify(oldObj[key]) !== JSON.stringify(newObj[key])) {
      // @ts-ignore
      diff[key] = newObj[key];
    }
  });
  return diff;
};
